module.exports = __webpack_public_path__ + "media/app/containers/CheckoutPage/icons/AddressMapIcon.6bcddeb0.svg";